var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"활성 계정"}},[_c('Accounts',{attrs:{"status":"ACTIVE"}})],1),_c('el-tab-pane',{attrs:{"label":"비활성 계정"}},[_c('Accounts',{attrs:{"status":"INACTIVE"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }